import { render, staticRenderFns } from "./MCQModification.vue?vue&type=template&id=56a56f5e&scoped=true&"
import script from "./MCQModification.vue?vue&type=script&lang=js&"
export * from "./MCQModification.vue?vue&type=script&lang=js&"
import style0 from "./MCQModification.vue?vue&type=style&index=0&id=56a56f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a56f5e",
  null
  
)

export default component.exports